"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _feedToolz = require("../feed-toolz");

var _FeaturedList = _interopRequireDefault(require("./FeaturedList"));

var _FeaturedCss = _interopRequireDefault(require("./Featured.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Featured = function Featured(_ref) {
  var feedData = _ref.feedData,
      styleVariants = _ref.styleVariants;

  var handleLinkClick = function handleLinkClick(linkout, e) {
    e.preventDefault();
    window.open(linkout, '_blank');
  };

  var fullTitleStyle = Object.assign({}, _FeaturedCss.default['featuredTitle'], styleVariants['featuredTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "featured-blogs-component",
    style: _FeaturedCss.default.component
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "row-content",
    style: _FeaturedCss.default.contentContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "featured-article-container",
    style: _FeaturedCss.default.featuredContainer,
    onClick: function onClick(e) {
      return handleLinkClick(feedData[0].link, e);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "featured-title",
    style: fullTitleStyle
  }, feedData[0].title), /*#__PURE__*/_react.default.createElement("img", {
    key: "featured-article-img",
    style: _FeaturedCss.default['featuredImage'],
    src: (0, _feedToolz.getSrcFromHtml)(feedData[0].content, true, 'xl'),
    alt: "featured-article-img"
  })), /*#__PURE__*/_react.default.createElement("div", {
    key: "article-list-container",
    style: _FeaturedCss.default.listContainer
  }, /*#__PURE__*/_react.default.createElement(_FeaturedList.default, {
    key: "featured-articles",
    data: feedData,
    styleVariants: styleVariants,
    handleClick: handleLinkClick
  }))));
};

var _default = (0, _radium.default)(Featured);

exports.default = _default;

//# sourceMappingURL=Featured.jsx.map